var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { CloseDialogIcon } from '../atoms/Icons';
import styled from 'styled-components';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogContentText, IconButton, } from '@mui/material';
var Dialog = styled(MuiDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiPaper-root {\n    min-width: 300px;\n  }\n\n  .MuiDialogTitle-root {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .MuiDialogContent-root {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n"], ["\n  .MuiPaper-root {\n    min-width: 300px;\n  }\n\n  .MuiDialogTitle-root {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .MuiDialogContent-root {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n"])));
export var HelpIconDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, title = _a.title, description = _a.description;
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        React.createElement(DialogTitle, null,
            title,
            React.createElement(IconButton, { onClick: onClose, size: "large" },
                React.createElement(CloseDialogIcon, null))),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, description))));
};
var templateObject_1;
